(function () {
  "use strict";

  var STORAGE_KEY = "theartfolio_reactions";
  var storageUsable = false;

  // Device-local by design. A future account/aggregate backend can be added
  // inside recordReaction() without changing discovery or collection callers.
  function testStorage() {
    try {
      var probe = STORAGE_KEY + "_probe";
      localStorage.setItem(probe, "1");
      localStorage.removeItem(probe);
      return true;
    } catch (error) {
      return false;
    }
  }

  function cleanId(id) {
    return String(id == null ? "" : id).trim();
  }

  function getAllReactions() {
    if (!storageUsable) return {};
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      if (!parsed || Array.isArray(parsed) || typeof parsed !== "object") return {};
      return Object.keys(parsed).reduce(function (result, id) {
        if (parsed[id] === "like" || parsed[id] === "dislike") result[id] = parsed[id];
        return result;
      }, {});
    } catch (error) {
      return {};
    }
  }

  function writeReactions(reactions) {
    if (!storageUsable) return false;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(reactions));
      return true;
    } catch (error) {
      return false;
    }
  }

  function getReaction(id) {
    return getAllReactions()[cleanId(id)] || null;
  }

  function setReaction(id, type) {
    id = cleanId(id);
    if (!id || (type !== "like" && type !== "dislike" && type !== null)) return false;
    var reactions = getAllReactions();
    if (type === null) delete reactions[id];
    else reactions[id] = type;
    if (!writeReactions(reactions)) return false;
    document.dispatchEvent(new CustomEvent("theartfolio:reactionchange", {
      detail: { id: id, reaction: type }
    }));
    return true;
  }

  function recordReaction(id, type) {
    // Future backend/analytics reporting belongs here; local state remains the
    // source of truth for this no-login version.
    return setReaction(id, type);
  }

  function resetDislikes() {
    var reactions = getAllReactions();
    var changed = false;
    Object.keys(reactions).forEach(function (id) {
      if (reactions[id] === "dislike") {
        delete reactions[id];
        changed = true;
      }
    });
    if (changed && !writeReactions(reactions)) return false;
    document.dispatchEvent(new CustomEvent("theartfolio:reactionchange", {
      detail: { id: null, reaction: null, resetDislikes: true }
    }));
    return true;
  }

  window.TheArtfolioReactions = {
    getReaction: getReaction,
    setReaction: setReaction,
    getAllReactions: getAllReactions,
    recordReaction: recordReaction,
    resetDislikes: resetDislikes
  };

  function refreshContainer(container) {
    var id = cleanId(container.dataset.reactionId);
    if (!id) {
      container.hidden = true;
      return;
    }
    container.hidden = false;
    var reaction = getReaction(id);
    container.classList.toggle("is-liked", reaction === "like");
    container.classList.toggle("is-disliked", reaction === "dislike");
    container.querySelectorAll("[data-reaction-action]").forEach(function (button) {
      var type = button.dataset.reactionAction;
      var active = reaction === type;
      button.setAttribute("aria-pressed", active ? "true" : "false");
      button.setAttribute(
        "aria-label",
        active
          ? (type === "like" ? "Remove like from this artwork" : "Undo not for me")
          : (type === "like" ? "Like this artwork" : "Not for me")
      );
    });
    var status = container.querySelector("[data-reaction-status]");
    if (status) {
      status.textContent = reaction === "like"
        ? "Artwork liked."
        : reaction === "dislike"
          ? "Artwork marked as not for me."
          : "No artwork reaction selected.";
    }
  }

  function refreshAll() {
    document.querySelectorAll("[data-reaction-card], [data-discover-reactions]").forEach(refreshContainer);
    applyCollectionTasteFilters();
  }

  var tasteFilterValue = "all";
  var TASTE_STORAGE_KEY = "theartfolio_collection_taste";

  function readStoredTaste() {
    try {
      var value = localStorage.getItem(TASTE_STORAGE_KEY);
      if (value === "like" || value === "dislike" || value === "all") return value;
    } catch (error) {}
    return "all";
  }

  function storeTaste(value) {
    try {
      localStorage.setItem(TASTE_STORAGE_KEY, value);
    } catch (error) {}
  }

  function countCollectionDislikes() {
    var count = 0;
    document.querySelectorAll("[data-reaction-collection] [data-reaction-card]").forEach(function (card) {
      var id = cleanId(card.dataset.reactionId);
      if (id && getReaction(id) === "dislike") count += 1;
    });
    return count;
  }

  function syncTasteFilterAvailability() {
    // Only show “Not for me” when a disliked print is on this collection grid —
    // not when dislikes exist elsewhere (Discover / other collections).
    var hasDislikes = countCollectionDislikes() > 0;

    if (!hasDislikes && tasteFilterValue === "dislike") {
      tasteFilterValue = "all";
      storeTaste("all");
    }

    document.querySelectorAll("[data-taste-filter]").forEach(function (group) {
      var btn = group.querySelector('[data-taste-value="dislike"]');
      if (!hasDislikes) {
        if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
        return;
      }
      if (!btn) {
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = "taste-filter-btn";
        btn.setAttribute("data-taste-value", "dislike");
        btn.textContent = "Not for me";
        group.appendChild(btn);
      }
      var active = tasteFilterValue === "dislike";
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function applyCollectionTasteFilters() {
    syncTasteFilterAvailability();
    var collections = document.querySelectorAll("[data-reaction-collection]");
    if (!collections.length) return;

    var filtering = tasteFilterValue !== "all";

    collections.forEach(function (grid) {
      var cards = grid.querySelectorAll("[data-reaction-card]");
      var visible = 0;
      cards.forEach(function (card) {
        var id = cleanId(card.dataset.reactionId);
        var reaction = id ? getReaction(id) : null;
        var show;
        if (tasteFilterValue === "all") {
          // All = browseable catalogue minus pieces marked “not for me”
          show = reaction !== "dislike";
        } else {
          show = reaction === tasteFilterValue;
        }
        card.classList.toggle("is-taste-hidden", !show);
        if (show) visible += 1;
      });

      var host = grid.parentElement;
      var empty = host && host.querySelector("[data-taste-empty]");
      if (empty) {
        empty.hidden = visible !== 0;
        if (tasteFilterValue === "all") {
          empty.textContent = "Everything on this page is marked “not for me”. Undo a few, open the Not for me tab, or reset hidden works in Discover.";
        } else if (tasteFilterValue === "like") {
          empty.textContent = "Nothing liked on this page yet. Heart a few pieces, then try again, or switch back to All.";
        } else {
          empty.textContent = "Nothing marked “not for me” on this page yet. Switch back to All to browse, or mark a few pieces as not for you.";
        }
      }

      var pagination = host && host.querySelector("[data-coll-pagination]");
      if (pagination) {
        pagination.hidden = filtering;
        pagination.setAttribute("aria-hidden", filtering ? "true" : "false");
      }

      var countEl = document.querySelector("[data-coll-count]");
      if (countEl) {
        if (tasteFilterValue === "all") {
          var total = parseInt(grid.getAttribute("data-coll-total"), 10);
          if (!isFinite(total)) total = cards.length;
          var hiddenDislikes = cards.length - visible;
          if (hiddenDislikes > 0) {
            countEl.textContent =
              visible +
              (visible === 1 ? " work" : " works") +
              " on this page";
          } else {
            countEl.textContent = total + (total === 1 ? " work" : " works");
          }
        } else {
          var label = tasteFilterValue === "like" ? "liked" : "not for me";
          countEl.textContent =
            visible +
            (visible === 1 ? " work" : " works") +
            " · " +
            label +
            " on this page";
        }
      }
    });

    document.querySelectorAll("[data-taste-filter]").forEach(function (group) {
      group.querySelectorAll("[data-taste-value]").forEach(function (btn) {
        if (btn.hidden) return;
        var active = btn.getAttribute("data-taste-value") === tasteFilterValue;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
    });
  }

  function setTasteFilter(value) {
    if (value !== "all" && value !== "like" && value !== "dislike") value = "all";
    tasteFilterValue = value;
    storeTaste(value);
    applyCollectionTasteFilters();
  }

  document.addEventListener("DOMContentLoaded", function () {
    storageUsable = testStorage();
    if (!storageUsable) {
      document.documentElement.classList.add("reactions-unavailable");
      return;
    }

    tasteFilterValue = readStoredTaste();

    document.addEventListener("click", function (event) {
      var tasteBtn = event.target.closest("[data-taste-value]");
      if (tasteBtn && tasteBtn.closest("[data-taste-filter]")) {
        setTasteFilter(tasteBtn.getAttribute("data-taste-value"));
        return;
      }
      var reactionButton = event.target.closest("[data-reaction-action]");
      if (reactionButton) {
        var container = reactionButton.closest("[data-reaction-card], [data-discover-reactions]");
        var id = container && cleanId(container.dataset.reactionId);
        if (!id) return;
        var requested = reactionButton.dataset.reactionAction;
        var next = getReaction(id) === requested ? null : requested;
        if (recordReaction(id, next)) refreshAll();
        return;
      }
      var reset = event.target.closest("[data-reset-dislikes]");
      if (reset && resetDislikes()) refreshAll();
    });

    document.querySelectorAll("[data-discover]").forEach(function (discover) {
      discover.addEventListener("discover:pick", function (event) {
        var controls = discover.querySelector("[data-discover-reactions]");
        var product = event.detail && event.detail.product;
        if (!controls || !product) return;
        controls.dataset.reactionId = product.handle || product.id || "";
        refreshContainer(controls);
      });
    });

    document.addEventListener("theartfolio:reactionchange", refreshAll);
    window.addEventListener("storage", function (event) {
      if (event.key === STORAGE_KEY || event.key === TASTE_STORAGE_KEY) refreshAll();
    });
    refreshAll();
  });
})();
